/**
 * 料金検索処理 ← TODO: index.js 料金検索だけとは限らない
 *
 * No.    日付          更新者    更新内容
 *   1    2021/10/13    庄子        新規作成
 *
 * @summary ユーティリティーフォーム関連
 * @copyright 2021, WINGSYSTEMS K.K.
 */
'use strict';

import '../../_initial';
import * as Common from '../../_common';
import {DateEx} from '../../common/dateex';

// 時計
const clockTimer = setInterval(() => {
    const nowInfo = (new DateEx()).dateParse();
    const weekendName = Common.Data.DayOfWeek[nowInfo.dayofweek].slice(0, 1);
    const msg = `${nowInfo.year}年${nowInfo.month}月${nowInfo.day}日(${weekendName})&nbsp;&nbsp;${nowInfo.hour}時${nowInfo.minute}分`;

    if (document.getElementById("clock").innerHTML !== msg)
    {
        document.getElementById("clock").innerHTML = msg;
    }

    // リロード
    const currentHm = parseInt(nowInfo.hour, 10) * 100 + parseInt(nowInfo.minute, 10);
    // 日付変更時間より小さい場合は2400足す
    const addHm = (currentHm < Common.Data.DateChangeHm) ? 2400 : 0;

    Common.Data.chargeReloadTimes.forEach(function(value) {
        // 更新時間を過ぎたらリロード
        if (value <= currentHm + addHm) {
            clearInterval(clockTimer);
            window.location.reload();
        }
    });
}, 1 * 1000);

// フォーカスしたらリロード
window.addEventListener('focus', (event) => {
    clearInterval(clockTimer);
    window.location.reload();
});
